/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyDTO } from './CompanyDTO';
import {
    CompanyDTOFromJSON,
    CompanyDTOFromJSONTyped,
    CompanyDTOToJSON,
} from './CompanyDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface CompanyPageDTO
 */
export interface CompanyPageDTO {
    /**
     * 
     * @type {Array<CompanyDTO>}
     * @memberof CompanyPageDTO
     */
    content?: Array<CompanyDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof CompanyPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof CompanyPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof CompanyPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof CompanyPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the CompanyPageDTO interface.
 */
export function instanceOfCompanyPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompanyPageDTOFromJSON(json: any): CompanyPageDTO {
    return CompanyPageDTOFromJSONTyped(json, false);
}

export function CompanyPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(CompanyDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function CompanyPageDTOToJSON(value?: CompanyPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(CompanyDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

